import { ApiVersion } from "../const";

export const get3DModel = (token: string) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}get3DModel`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })
}

export const get3DModelModul = (token: string, key: string) => {
  const url = `${process.env.REACT_APP_API_URL}${ApiVersion}get3dObjectModel?key=${encodeURIComponent(key)}`

  return fetch(url, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => {
    if (response.ok) return response.json()
    throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
  })
}

